import { Injectable } from '@angular/core';
import { ElectronWrapperService } from './electron-wrapper';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(private electronWrapper: ElectronWrapperService) {}

  log(message: any, context: string = 'General'): void {
    const logEntry = JSON.stringify({ context, timestamp: new Date().toISOString(), message });

    this.electronWrapper.logToFile(logEntry); // Delegate log writing
  }
}
